export const DEFAULT_PAGE_SIZE = 100;
export const MAX_PAGINATED_REQUESTS = 30;
